var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header-nav" }, [
        _c("div", { staticClass: "logo" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-box" },
          _vm._l(_vm.navList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                ref: "containerBoxItem",
                refInFor: true,
                staticClass: "container-box-item",
                on: {
                  mouseenter: function ($event) {
                    return _vm.hoverTab(index)
                  },
                  mouseleave: function ($event) {
                    return _vm.hoverTabLeave()
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "container-box-text",
                    on: {
                      click: function ($event) {
                        return _vm.handleGoto(item, index)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.language == "zh" ? item.nameZh : item.nameEn
                        ) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                index !== 0
                  ? _c("i", { staticClass: "el-icon-caret-bottom" })
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-nav-right" },
          [
            _c("div", [_vm._v("注册")]),
            _vm._v(" "),
            _c("div", { staticClass: "header-nav-right-border" }),
            _vm._v(" "),
            _c("el-avatar", { attrs: { icon: "el-icon-user-solid" } }),
            _vm._v(" "),
            !_vm.userInfo.accountName
              ? _c(
                  "div",
                  {
                    staticStyle: { margin: "0 20px 0 10px", cursor: "pointer" },
                    on: { click: _vm.handleGoLogin },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("home.noLogin")) + "\n      "
                    ),
                  ]
                )
              : _c(
                  "div",
                  {
                    staticStyle: { margin: "0 20px 0 10px", cursor: "pointer" },
                    on: { click: _vm.handleToUserCenter },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.userInfo.accountName) +
                        "\n      "
                    ),
                  ]
                ),
            _vm._v(" "),
            !_vm.userInfo.accountName
              ? _c(
                  "div",
                  {
                    staticStyle: { margin: "0 20px 0 10px", cursor: "pointer" },
                    on: { click: _vm.handleLogOut },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("home.logOut")) + "\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("router-link", { attrs: { to: "/helpDocuments" } }, [
              _c("i", { staticClass: "el-icon-arrow-down" }),
            ]),
            _vm._v(" "),
            _vm.language === "en"
              ? _c(
                  "div",
                  {
                    staticStyle: { "margin-left": "16px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSetLanguage("zh")
                      },
                    },
                  },
                  [_vm._v("CH")]
                )
              : _c(
                  "div",
                  {
                    staticStyle: { "margin-left": "16px", cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.handleSetLanguage("en")
                      },
                    },
                  },
                  [_vm._v("ZH")]
                ),
            _vm._v(" "),
            _c("i", { staticClass: "el-icon-arrow-down" }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _c(
          "div",
          { ref: "containerListTab", staticClass: "container-list-tab" },
          _vm._l(_vm.navTabList, function (item, index) {
            return _c(
              "div",
              { key: index, staticClass: "container-list-item" },
              [
                _c("i", { staticClass: "el-icon-tickets" }),
                _vm._v(" " + _vm._s(item.name) + "\n      "),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }